import { render, staticRenderFns } from "./NewArticleForm.vue?vue&type=template&id=1c3c88a6&scoped=true"
import script from "./NewArticleForm.vue?vue&type=script&lang=js"
export * from "./NewArticleForm.vue?vue&type=script&lang=js"
import style0 from "./NewArticleForm.vue?vue&type=style&index=0&id=1c3c88a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c88a6",
  null
  
)

export default component.exports